import { connect } from 'react-redux';

import EntitiesComponent from '../Entities/EntitiesBody';
import { SCOPE } from '../../config/constants';
import { routeToScope } from '../../helpers/helpersts';
import {
  getEntitiesDataOps,
  loadTeams, createEntityDataOps, editEntityDataOps, deleteEntityDataOps
} from '../../store/actions';

const mapStateToProps = (state, ownProps) => {
  const path = state.router.location.pathname;
  const scope = routeToScope(path);
  const isDataOpsPage = scope === SCOPE.DATAOPS.ENTITIES;
  return {
    user: state.user,
    entitiesObject: state.entities.entities,
    messageLoading: state.entities.entities ? null : 'Unable to find data',
    teamId: ownProps.practice.home_team_id,
    isDataOpsPage
  };
};

const mapDispatchToProps = (dispatch, { practice }) => {
  return {
    loadEntities: () => {
      dispatch(getEntitiesDataOps(practice));
    },
    loadTeams() {
      dispatch(loadTeams());
    },
    createEntity: (entity, extraData) => {
      dispatch(createEntityDataOps(entity, extraData, practice));
    },
    editEntity: (entity, extraData) => {
      dispatch(editEntityDataOps(entity, extraData, practice));
    },
    deleteEntity: (entity) => {
      dispatch(deleteEntityDataOps(entity, practice));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesComponent);
